import { getMarketingDomain } from './getAppByDomain';

export const replaceDomain = (url: string, host: string) =>
    url.replace(/((https|http):\/\/)([^/])+/, '$1' + host);

export const toMarketingUrl = (url: string) => replaceDomain(url, getMarketingDomain());
